const {
  blockEditor: { MediaUpload, MediaUploadCheck },
  i18n: { __ },
  element: { useEffect, useState },
  components: { Button },
} = wp;

const FileLink = (props) => {
  const { onMetaUpdate, featuredImageUrl, learnMoreLinkFileMetaValue } = props;

  const [fileId, setFileId] = useState(learnMoreLinkFileMetaValue || 0);
  const [fileName, setFileName] = useState(null);

  useEffect(() => {
    if (fileId) {
      setFileName(featuredImageUrl);
    }
  }, [featuredImageUrl]); // eslint-disable-line

  return (
    <div className="components-base-control link-control-sidebar">
      <label
        htmlFor="download-file"
        className={'components-base-control__label'}
      >
        Download File
      </label>
      <div id="download-file" className="editor-post-featured-image">
        <MediaUploadCheck>
          <MediaUpload
            onSelect={(img) => {
              const { id: imgId } = img;
              setFileId(imgId);
              setFileName(img.filename);
              onMetaUpdate('learn_more_link_file', imgId);
            }}
            value={fileId}
            render={({ open }) => (
              <>
                {fileId === 0 && (
                  <Button
                    className={
                      fileId === 0
                        ? 'editor-post-featured-image__toggle'
                        : 'editor-post-featured-image__preview'
                    }
                    onClick={open}
                  >
                    {fileId === 0 && __('Choose the File', '')}
                  </Button>
                )}
                {fileId !== 0 && (
                  <>
                    {fileName && (
                      <div className="file-wrap">
                        <div className="file-info">
                          <p>
                            <strong>File name: </strong>
                            <strong data-name="title">{fileName}</strong>
                          </p>
                        </div>
                      </div>
                    )}
                    <Button onClick={open} isPrimary>
                      {__('Replace the File', '')}
                    </Button>
                    <Button
                      onClick={() => {
                        setFileId(0);
                        setFileName(null);
                        onMetaUpdate('learn_more_link_file', 0);
                      }}
                      isSecondary
                      isDestructive
                    >
                      {__('Remove the File', '')}
                    </Button>
                  </>
                )}
              </>
            )}
          ></MediaUpload>
        </MediaUploadCheck>
      </div>
    </div>
  );
};

export default FileLink;
